
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h17.8v21.07H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M24 0C10.745 0 0 10.746 0 23.998 0 37.254 10.745 48 24 48s24-10.746 24-24.002C48 10.746 37.255 0 24 0z","fill":"#4D58A3"}}),_c('g',{attrs:{"transform":"translate(15 13)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M10.222 10.47l7.157-8.713C18.177.787 17.808 0 16.556 0H1.489C.237 0-.148.8.63 1.787l6.95 8.815L.42 19.313c-.797.97-.429 1.758.824 1.758H16.31c1.252 0 1.637-.8.86-1.787l-6.95-8.815z","fill":"#FFF","mask":"url(#b)"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/object_forms/co.svg